import React, { memo, useMemo } from "react";
import { Button, Grid, Typography } from "@mui/material";
import { useFormikContext } from "formik";

import FormikMuiSaveAsDraftButton from "@/components/muiCustom/buttons/FormikMuiSaveAsDraftButton";
import { rrdDirectMailCampaignHelper } from "../utils/rrdDirectMailHelper";

type RRDSubmitProps = {
  isPreview?: boolean;
  totalLocationsCount?: number;
};

function RRDSubmit({ isPreview = false, totalLocationsCount }: RRDSubmitProps) {
  const { values } = useFormikContext<Record<string, any>>();

  const fullyFilledLocations = useMemo(() => {
    const locations = { ...values };
    delete locations.is_draft;
    return rrdDirectMailCampaignHelper.fetchFullyFilledLocations(locations);
  }, [values]);

  return (
    <Grid
      container
      spacing={2}
      justifyContent={{
        xs: "center",
        md: "flex-end",
      }}
      alignItems="center"
      sx={{ mt: 10 }}
    >
      <Grid size={{ xs: 12, md: "auto" }}>
        <Typography variant="body2">
          Selection made for {fullyFilledLocations?.length} of{" "}
          {totalLocationsCount} locations
        </Typography>
      </Grid>
      {!isPreview && (
        <Grid size={{ xs: 12, sm: 6, md: "auto" }} textAlign="center">
          <FormikMuiSaveAsDraftButton
            variant="outlined"
            color="primary"
            sx={{ px: 5 }}
            fullWidth
            disabled={!fullyFilledLocations?.length}
          />
        </Grid>
      )}
      <Grid size={{ xs: 12, sm: 6, md: "auto" }} textAlign="center">
        <Button
          variant="contained"
          color="primary"
          type="submit"
          sx={{ px: 7 }}
          fullWidth
          disabled={!fullyFilledLocations?.length}
        >
          Confirm
        </Button>
      </Grid>
    </Grid>
  );
}

export default memo(RRDSubmit);
